import { Children } from 'react';
var getChildrenLength = function getChildrenLength(children) {
  return Children.toArray(children).length;
};
export { getChildrenLength };